import { getDefaultRegistry } from '@rjsf/core';
import type { FieldProps } from '@rjsf/utils';
import type { ReactElement } from 'react';

import { MenuBuilderField } from '../widgets/MenuBuilder/MenuBuilderField';
import type { MenuItem } from '../widgets/MenuBuilder/MenuBuilderCore';
import { ImageLinkManagerField } from '../widgets/ImageLinkManager/ImageLinkManagerField';
import type { ImageLinkItem } from '../widgets/ImageLinkManager/ImageLinkRow';

const DefaultArrayField = getDefaultRegistry().fields.ArrayField;

// The backend uiSchema declares the menu builder as `ui:widget: menuBuilder`,
// but rjsf does not pass `errorSchema` to custom array widgets — only to
// fields. Intercept that uiSchema here and render a field so per-item
// validation errors reach the menu builder.
export function ArrayField(props: FieldProps): ReactElement {
  if (props.uiSchema?.['ui:widget'] === 'menuBuilder') {
    return <MenuBuilderField {...(props as FieldProps<MenuItem[]>)} />;
  }
  if (props.uiSchema?.['ui:widget'] === 'imageLinkManager') {
    return <ImageLinkManagerField {...(props as FieldProps<ImageLinkItem[]>)} />;
  }

  return <DefaultArrayField {...props} />;
}
